import type { ProfileDraft } from "../lib/profileDraft";
import { Field, Input } from "./ui";

/**
 * The writable half of a profile, in one place.
 *
 * Shared by the signup wizard and the edit page because `PUT /me/profile`
 * replaces the stored record (see `profileDraft`): a field present on one form
 * and missing from the other would be erased every time a coach used the form
 * without it. Keeping the set here means adding a field adds it to both.
 */
export function ProfileFields({
  draft,
  setDraft,
  autoFocus = false,
}: {
  draft: ProfileDraft;
  setDraft: (next: ProfileDraft) => void;
  autoFocus?: boolean;
}) {
  return (
    <>
      <Field label="Display name" hint="How organizers see you on registrations and rosters.">
        <Input
          value={draft.displayName}
          onChange={(e) => setDraft({ ...draft, displayName: e.target.value })}
          placeholder="e.g. Dana Ruiz"
          autoComplete="name"
          autoFocus={autoFocus}
          required
        />
      </Field>
      <Field
        label="Phone (optional)"
        hint="Organizers call this when a game moves or a field changes."
      >
        <Input
          inputMode="tel"
          autoComplete="tel"
          value={draft.phone}
          onChange={(e) => setDraft({ ...draft, phone: e.target.value })}
          placeholder="e.g. (555) 012-3344"
        />
      </Field>
    </>
  );
}
